import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon';
const _IconControlLock = (props) => {
    const { size, ...rest } = props;
    return size === '24' ? (React.createElement(Icon, { svg: React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { fillRule: "evenodd", d: "M8 6a4 4 0 1 1 8 0v4h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h1zm1.5 4h5V6a2.5 2.5 0 0 0-5 0zm-2 8.5v-7h9v7z", fill: "currentColor" })), height: "24", width: "24", ...rest })) : (React.createElement(Icon, { svg: React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
            React.createElement("path", { fillRule: "evenodd", d: "M10.667 7H11a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h.334V4.667a2.667 2.667 0 0 1 5.333 0zM6.834 7V4.667a1.167 1.167 0 1 1 2.333 0V7zM5.5 12.5v-4h5v4z", fill: "currentColor" })), height: "16", width: "16", ...rest }));
};
const defaultProps = {
    size: '24',
};
export const IconControlLock = styled(_IconControlLock) ``;
IconControlLock.defaultProps = defaultProps;
//# sourceMappingURL=IconControlLock.js.map